import "./styles.css";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { getLocalStorageData } from "../../utils/localStorage";
// import primaryLogo from "./images/primary-blue-logo.svg";
// import primaryBlueLogo from "./images/primary-blue-logo.svg";
// import secondaryLogo from "./images/secondary-logo2.svg";

function Logo( props: any) {   
    const userData = props.forceDefault ? null : getLocalStorageData("userData");
    return (
        <Link to={props?.redirectUrl ?? "/dashboard"} className="sidebarLogo">
            {props?.variant === "secondary" ? (
                <Box className="secondaryLogoContainer" >
                    {props.brandName || userData?.userType === "SuperAdmin"  || (!userData?.logo && !userData?.employee?.organization?.logo) ? (
                        <Typography variant="h2">{props.brandName ?? "ETMS"}</Typography>
                    ) : (
                        <Box
                            component="img"
                            src={userData?.logo || userData?.employee?.organization?.logo}
                            // alt={userData?.employee?.organization?.name || "Organization Logo"}
                            sx={{
                                width: '50px',
                                height: 'auto',
                                objectFit: 'contain',
                            }}
                        />
                    )}
                </Box>
                // <Box className="secondaryLogoContainer">
                //   <Typography variant="h2">ETMS</Typography>
                // </Box>
            ) : (
                <Box className="primaryLogoContainer">
                    {props.brandName || userData?.userType === "SuperAdmin" || (!userData?.logo && !userData?.employee?.organization?.logo) ? (
                        <Typography variant="h2">{props.brandName ?? "ETMS"}</Typography>
                    ) : (
                        <Box
                            component="img"
                            src={userData?.logo || userData?.employee?.organization?.logo}
                            // alt={userData?.employee?.organization?.name || "Organization Logo"}
                            sx={{
                                width: '100%',
                                height: '50px',
                                objectFit: 'contain',
                            }}
                        />
                    )}
                </Box>
            )}
        </Link>
    );
}

export default Logo;
